
var dateObj = new Date();

function Location(name, hourString, hours){
	this.name = name;
	this.hourString = hourString;
	this.hours = hours;
}

var franklin = new Location(
	"260 Franklin St. Boston, Ma 02110",
  "Mon-Fri: 7am - 2pm",
/*	[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]]  */
 	[[0,0],[700,1400],[700,1400],[700,1400],[700,1400],[700,1400],[0,0]]
);

var broad = new Location(
	"50 Broad St. Boston, Ma 02109",
  "Mon-Fri: 7:00am - 5:00pm",
	[[0,0],[700,1700],[700,1700],[700,1700],[700,1700],[700,1700],[0,0]]
);

var high = new Location(
	"100 High St. Boston, Ma 02110",
  "Mon-Fri: 7:00am - 4:00pm",
	[[0,0],[700,1600],[700,1600],[700,1600],[700,1600],[700,1600],[0,0]]
);

var washington = new Location(
	"Lower Mills Cafe<br>1170 Washington St. Dorchester, Ma 02124",
	"Everyday: 6:30am - 2:00pm",
	[[630,1400],[630,1400],[630,1400],[630,1400],[630,1400],[630,1400],[630,1400]]
);

var dorchester = new Location(
	"Ashmont Cafe<br>1906 Dorchester Ave. Dorchester, Ma 02124",
	"Mon-Fri: 6:30am - 3:30pm",
	[[0,0],[630,1530],[630,1530],[630,1530],[630,1530],[630,1530],[0,0]]
);

var state = new Location(
	"255 State St. Boston, Ma 02110",
	"Mon-Fri: 7:30am - 3:30pm",
	[[0,0],[730,1530],[730,1530],[730,1530],[730,1530],[730,1530],[0,0]]
);



function DateComparison(Location){
	var hours = Location.hours[dateObj.getDay()];
	var closingTime = hours[2];
	var openingTime = hours[0];
	var timeTotal = "" + dateObj.getHours() + dateObj.getMinutes();
	console.log(timeTotal);
	var isItOpen = "";
	var toHtml = "";
	var label;

	if(timeTotal >= hours[1] && hours[0] <= timeTotal){

		console.log(Location.name + " is closed.");
		console.log(dateObj.getHours() + " " + Location.closeHour);
		console.log("TOTAL TIME: " + timeTotal);
		isItOpen = "closed";
		label = "danger";

	}else{
		console.log("TOTAL TIME: " + timeTotal);
		console.log(Location.name + " is open.");	
		console.log(dateObj.getHours() + " " + Location.closeHour);
		isItOpen = "open";
		label = "success";

	}

	toHtml += "<a href='http://maps.google.com/maps?q=" + escape(Location.name) + "' title='link to map'>";
	toHtml += "<div class='col-md-4'><section><div class='overlay'></div>";
	toHtml += "<h4>" + Location.name + "</h4>";
	toHtml += "<p>" + Location.hourString + "</p>"
	toHtml += "<span class='label label-" + label + "'>" + isItOpen + "</span>";
	toHtml += "</section>";
	toHtml += "</div></a>";
	
	$(".cta-locations .container-fluid-wide .row").append(toHtml);
}


//DateComparison(franklin);
//DateComparison(broad);
//DateComparison(high);
DateComparison(washington);
//DateComparison(dorchester);
//DateComparison(state);



$(document).ready(function(){
	if($(window).width() <= 768) {
		$(".follow").removeClass("affix");
	}
});



